import { css as e, styled as t } from "styled-components";
//#region src/components/Notification/styled/Notification.styled.ts
var n = (e, t) => {
	switch (e) {
		case "green": return t.colors.success;
		case "amber": return t.colors.warning;
		case "pink": return t.colors.primary;
		case "neutral": return t.colors.mutedForeground;
	}
}, r = t.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    border-radius: ${({ theme: e }) => e.radii.xl};
    padding: ${({ theme: e }) => e.spacing(2.5)};
    transition:
        box-shadow ${({ theme: e }) => e.transitions.normal},
        transform ${({ theme: e }) => e.transitions.normal};

    ${({ $unread: t, theme: n }) => t ? e`
                  background-color: ${n.colors.card};
                  box-shadow: ${n.shadows.soft};
              ` : e`
                  background-color: ${n.colors.muted};
                  box-shadow: none;
              `}
`, i = t.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1.5)};
`, a = t.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    min-width: 0;
`, o = t.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 9999px;
    flex-shrink: 0;
    /* soft colorful backdrop — tone color at low alpha */
    background-color: ${({ $tone: e, theme: t }) => `${n(e, t)}22`};
    color: ${({ $tone: e, theme: t }) => n(e, t)};

    svg {
        width: 20px;
        height: 20px;
    }
`, s = t.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(.5)};
    min-width: 0;
`, c = t.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    flex-shrink: 0;
`, l = t.span`
    white-space: nowrap;
`, u = t.span`
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    background-color: ${({ theme: e }) => e.colors.primary};
    flex-shrink: 0;
`, d = t.div`
    color: ${({ theme: e }) => e.colors.mutedForeground};
    padding-left: ${({ theme: e }) => e.spacing(7)}; /* align under the title, past the icon */
`, f = t.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme: e }) => e.spacing(1)};
    padding-left: ${({ theme: e }) => e.spacing(7)};
`, p = t.span`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
    padding: ${({ theme: e }) => e.spacing(.75, 1.5)};
    border-radius: 9999px;
    background-color: ${({ $tone: e, theme: t }) => `${n(e, t)}1A`};
    color: ${({ $tone: e, theme: t }) => n(e, t)};

    svg {
        width: 14px;
        height: 14px;
    }
`, m = t.div`
    margin-top: ${({ theme: e }) => e.spacing(1)};
`;
//#endregion
export { a as HeaderLeft, c as HeaderRight, s as HeaderText, o as IconBackdrop, d as StyledBody, m as StyledFooter, i as StyledHeader, r as StyledNotification, p as StyledTag, f as StyledTags, l as TimestampWrapper, u as UnreadDot };
